module.exports = "/static/video/algeria.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/img/algeria.mp4
// module id = 390
// module chunks = 0